window.cartPageAjaxUpdate = function() {
  (async function() {
    try {
      const container = document.querySelector('.main-cart__items-container #cart-recomdend-product');
      if (!container) {
        console.error("cartPageAjaxUpdate: No .main-cart__items-container found in current document");
        return;
      }
      let resp;
      try {
        resp = await fetch(window.location.href, { credentials: 'same-origin' });
      } catch (fetchErr) {
        console.error("cartPageAjaxUpdate: Fetch to current page failed", fetchErr);
        return;
      }
      if (!resp.ok) {
        console.error(`cartPageAjaxUpdate: Fetch failed with status ${resp.status}`);
        return;
      }

      let text;
      try {
        text = await resp.text();
      } catch(parseErr) {
        console.error("cartPageAjaxUpdate: Error reading response text", parseErr);
        return;
      }

      let tempDiv = document.createElement('div');
      tempDiv.innerHTML = text;

      const newContainer = tempDiv.querySelector('.main-cart__items-container #cart-recomdend-product');
      if (newContainer) {
        // Try updating HTML
        try {
          container.innerHTML = newContainer.innerHTML;
        } catch(domErr) {
          console.error("cartPageAjaxUpdate: Failed to update innerHTML", domErr);
          return;
        }

        // Swiper initialization (fail gracefully)
        try {
          var swiper = new Swiper(".cart-page-upsells", {
            slidesPerView: 1.2,
            spaceBetween: 30,
            navigation: {
              nextEl: ".cart-page-upsells-next",
              prevEl: ".cart-page-upsells-prev",
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true
            },
            breakpoints: {
              640: {
                slidesPerView: 2.2,
              },
              768: {
                slidesPerView: 3.2,
              },
              1024: {
                slidesPerView: 3,
              }
            }
          });
        } catch(swiperErr) {
          console.error("cartPageAjaxUpdate: Swiper failed to initialize", swiperErr);
        }
      } else {
        console.warn('cartPageAjaxUpdate: No .main-cart__items-container found in fetched page');
      }
    } catch (e) {
      console.error("cartPageAjaxUpdate: Unexpected error", e);
    }
  })();
};